<template>
    <section class="detail">

        <navigation selected="confirmation"></navigation>

        <div class="inner">

            <div class="line"></div>

            <h1 class="print-title">La Source - Bains nordiques</h1>


            <div class="gift_cards_header">
                <h1>{{ copydeck.page_confirmation.txt_your_receipt[lang] }}</h1>
            </div>

            <div class="cart_confirmation">
                <div class="cart_confirmation__content">
                    <p>
                        <span class="label" v-html="copydeck.page_confirmation.txt_transaction[lang]"></span>
                        <span class="value">{{ copydeck.page_confirmation[paymentConfirmation.status ?? "succeeded"][lang] }}</span>
                    </p>
                </div>
                <!-- div.cart_confirmation__content -->

                <div class="cart_confirmation__content">
                    <p>
                        <span class="label" v-html="copydeck.page_confirmation.txt_date[lang]"></span>
                        <span class="value">{{ paymentConfirmation.date }}</span>
                    </p>
                </div>
                <!-- div.cart_confirmation__content -->

                <div class="cart_confirmation__content">
                    <p>
                        <span class="label" v-html="copydeck.page_confirmation.txt_order_id[lang]"></span>
                        <span class="value">{{ paymentConfirmation.order_id }}</span>
                    </p>
                </div>
                <!-- div.cart_confirmation__content -->

                <div class="cart_confirmation__content">
                    <p>
                        <span class="label" v-html="copydeck.page_confirmation.txt_auth_code[lang]"></span>
                        <span class="value">{{ paymentConfirmation.auth_code }}</span>
                    </p>
                </div>
                <!-- div.cart_confirmation__content -->

                <!-- 2023-06-29 removed : https://app.clickup.com/t/10518399/BUG-5858
                   <div class="cart_confirmation__content">
                       <p>
                           <span class="label">{{ copydeck.page_confirmation.txt_payments_reference[lang] }}&nbsp;:</span>
                           <span class="value">{{ paymentConfirmation.payments_reference }}</span>
                       </p>
                   </div> -->
                <!-- div.cart_confirmation__content -->

                <!-- 2023-06-29 removed : https://app.clickup.com/t/10518399/BUG-5858
                               <div class="cart_confirmation__content">
                                   <p>
                                       <span class="label">{{ copydeck.page_confirmation.txt_scheme_reference_data[lang] }}&nbsp;:</span>
                                       <span class="value">{{ paymentConfirmation.scheme_reference_data }}</span>
                                   </p>
                               </div>-->
               <!-- div.cart_confirmation__content -->

                <div class="cart_confirmation__content">
                    <p>
                        <span class="label" v-html="copydeck.page_confirmation.txt_card_holder[lang]"></span>
                        <span class="value">{{ paymentConfirmation.card_holder }}</span>
                    </p>
                </div>

                <div class="cart_confirmation__content">
                    <p>
                        <span class="label" v-html="copydeck.page_confirmation.txt_email[lang]"></span>
                        <span class="value">{{ invoice.email }}</span>
                    </p>
                </div>
                <!-- div.cart_confirmation__content -->

                <div class="cart_confirmation__content">
                    <p>
                        <span class="label" v-html="copydeck.page_confirmation.txt_credit_card_type[lang]"></span>
                        <span class="value">{{ paymentConfirmation.card_type == "VI" ? "Visa": "Mastercard" }}</span>
                    </p>
                </div>
                <!-- div.cart_confirmation__content -->


                <!-- div.cart_confirmation__content -->

                <div class="cart_confirmation__content"  v-if="paymentConfirmation.deliveryMethod === 'mail'">
                    <p>
                        <span class="label fw-700" v-html="copydeck.page_confirmation.delivery_mail[lang]"></span>
                    </p>
                    <p v-for="key in shippingRow">
                        <span class="label">
                            {{ copydeck.page_confirmation["shipping_" + key][lang] }}
                        </span>
                        <span class="value">
                            {{ paymentConfirmation.shipping[key] ?? ""}}
                        </span>
                    </p>
                </div>
                <!-- div.cart_confirmation__content -->
            </div>

            <div class="cart_resume">
                <subtotal></subtotal>
            </div>

            <div class="wrapper_btn">
                <button type="button" role="button" class="cta next" onclick="window.print();">
                    <span>{{ copydeck.page_confirmation.btn_print_receipt[lang] }}</span>
                </button>
            </div>

        </div>

    </section>
</template>

<script>
import Navigation from "../components/Navigation.vue";
import Subtotal   from "../components/Subtotal.vue";

export default {
    name: "PrintConfirmation",
    components: {Subtotal, Navigation},

    created() {
        // parent.debouncedResize;
    }
}
</script>

<script setup>

    import {useMainStore} from "../stores/main";
    import {storeToRefs}  from "pinia";
    import {onMounted}    from "vue";
    import {useRouter}    from "vue-router";

    let store = useMainStore();
    let router = useRouter();
    let { copydeck, lang, paymentConfirmation, invoice, orderCount } = storeToRefs(store);

    let shippingRow = ["firstname", "lastname", "address1", "address2", "city", "postal_code", "province", "country"];

    onMounted ( () =>
                {
                    if (orderCount.value === 0)
                    {
                        router.push({name: "Order"})
                    }
                })

</script>
